import React from 'react';

export function getErrorPageTextProps() {
  const isRenterHub = typeof window !== 'undefined' && location.pathname.startsWith('/renter-hub');

  return {
    homePageText: isRenterHub ? 'Go to your rental' : 'Go to Rental Manager',
    homePageUrl: isRenterHub ? '/renting/your-rental' : '/rental-manager/',
  };
}

export function getErrorPageAction() {
  const { homePageText, homePageUrl } = getErrorPageTextProps();
  return React.createElement('a', { href: homePageUrl }, homePageText);
}
